import { g as getIntrinsic } from '../get-intrinsic/index.js';
import './index.js';
import { c as callBind$1 } from '../../_vendor/call-bind/index.js_commonjs-module.js';

var GetIntrinsic = getIntrinsic;

var callBind = callBind$1.exports;

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

export { callBound as c };
